import { render, staticRenderFns } from "./InventoryManagement.vue?vue&type=template&id=41eff50f&scoped=true"
import script from "./InventoryManagement.vue?vue&type=script&lang=js"
export * from "./InventoryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eff50f",
  null
  
)

export default component.exports